import { cn } from '@/lib/utils'

interface Props {
  status: 'proposto' | 'confirmado'
  proposedLabel: string
  confirmedLabel: string
  showConfirmed?: boolean
  showLabel?: boolean
  className?: string
}

export default function FdeRecordStatus({
  status,
  proposedLabel,
  confirmedLabel,
  showConfirmed = false,
  showLabel = false,
  className,
}: Props) {
  if (status === 'confirmado' && !showConfirmed) return null

  const label = status === 'confirmado' ? confirmedLabel : proposedLabel

  return (
    <span
      className={cn('inline-flex shrink-0 items-center gap-1.5 text-[10px] font-medium text-muted-foreground', className)}
      title={label}
      aria-label={label}
      data-state={status}
    >
      <span className={cn('size-1.5 rounded-full', status === 'confirmado' ? 'bg-emerald-500/75' : 'bg-warning/75')} />
      {showLabel && <span>{label}</span>}
    </span>
  )
}
